import i18n from '@/i18n.json';

/** Countries that take "the" in running English text ("in the United States"). */
const takesArticle = new Set([
  'AE', // United Arab Emirates
  'CD', // Democratic Republic of the Congo
  'CF', // Central African Republic
  'CG', // Republic of the Congo
  'CI', // Ivory Coast
  'CZ', // Czech Republic
  'DO', // Dominican Republic
  'GB', // United Kingdom
  'GM', // Gambia
  'KM', // Comoros
  'KY', // Cayman Islands
  'NL', // Netherlands
  'PH', // Philippines
  'TC', // Turks and Caicos
  'US', // United States
  'VG', // British Virgin Islands
]);

/**
 * A country's name as it reads inside a sentence: "Gift cards in the United
 * States", "in Canada". Only English needs the article; every other locale
 * gets the name unchanged (their grammar is handled in the translation).
 *
 * Use the plain `country.name` where the name stands alone (titles, labels).
 */
export const countryNameInSentence = (country, locale = i18n.defaultLocale) => {
  if (!country?.name) return '';

  const name = country.name.replace(/\s+/g, ' ').trim();

  if (locale !== i18n.defaultLocale) return name;

  // "The Bahamas" is stored with its article.
  if (name.startsWith('The ')) return `the ${name.slice(4)}`;

  return takesArticle.has(country.id) ? `the ${name}` : name;
};
